// src/components/AdminRoute.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSpinner, FaGuitar } from "react-icons/fa";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const AdminRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("Auth state changed:", currentUser);
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
        navigate("/admin/login", { replace: true });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-950 flex items-center justify-center">
        <div className="text-center">
          <div className="relative inline-block mb-4">
            <FaGuitar className="text-gray-600 text-4xl animate-pulse" />
            <FaSpinner className="absolute -top-2 -right-2 animate-spin text-blue-500 text-2xl" />
          </div>
          <div className="text-white text-lg">Kimlik doğrulanıyor...</div>
          <div className="text-gray-500 text-sm mt-2">Lütfen bekleyin</div>
        </div>
      </div>
    );
  }

  return user ? children : null;
};

export default AdminRoute;